import Instagram from "../assests/icons/Instagram";
import FaceBook from "../assests/icons/FaceBook";
import Linkedin from "../assests/icons/Linkedin";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const linkObj = {
    facebook: "https://www.facebook.com/share/1BaavPiay8/",
    linkedin:
      "https://www.linkedin.com/company/shapielou-inc./",
    twitter: "https://twitter.com/",
    instagram: "https://www.instagram.com/pepli_app?igsh=ZzhjN2prNzBvbTBw",
  };

  const handleClick = (name) => {
    const url = linkObj[name];
    window.open(url, "_blank");
  };

  return (
    <footer className="bg-white py-5 px-36 text-black flex justify-between items-center max-[1215px]:flex-col-reverse max-xl:flex-col max-xl:space-y-4 max-[620px]:px-10">
      <p>
        <Link
          to="https://prodapi.pepliapp.com/api/v1/web/terms-of-use"
          className="hover:text-[#30D5C8]"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms & Conditions
        </Link>{" "}
        |{" "}
        <Link
          to="https://prodapi.pepliapp.com/api/v1/web/privacy-policy"
          className="hover:text-[#30D5C8]"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </Link>
      </p>
      <p className="max-[1215px]:m-0 max-[1215px]:text-center">
        © Copyright {currentYear} Pepli. All rights reserved
      </p>
      <div className="flex space-x-4 h-6 max-[1215px]:mb-2">
        <FaceBook
          className="cursor-pointer hover:text-black"
          onClick={() => handleClick("facebook")}
        />
        <Linkedin
          className="cursor-pointer hover:text-[#30D5C8]"
          onClick={() => handleClick("linkedin")}
        />
        <Instagram
          className="cursor-pointer hover:text-[#30D5C8]"
          onClick={() => handleClick("instagram")}
        />
      </div>
    </footer>
  );
};

export default Footer;
